
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTopbarMessageItem as ObcTopbarMessageItemElement} from '@oicl/openbridge-webcomponents/dist/components/topbar-message-item/topbar-message-item.js';
 
 
 

 
 export const ObcTopbarMessageItem = createComponent({
   react: React,
   tagName: 'obc-topbar-message-item',
   elementClass: ObcTopbarMessageItemElement,
   events: {
     
     onMessageClick: 'message-click' as EventName<CustomEvent<void>>,
     onActionClick: 'action-click' as EventName<CustomEvent<void>>,
   }
  });
 
 